import { useQuery } from "@tanstack/react-query";
import { getPostCategories } from "../../api/apiStorefront";
import i18next from "i18next";

/**
 * Hook to fetch blog post categories with post counts
 */
export function useGetPostCategories() {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["postCategories", i18next.language],
        queryFn: () => getPostCategories(),
        retry: false,
        staleTime: 1000 * 60 * 15, // 15 minutes (categories don't change often)
        cacheTime: 1000 * 60 * 30, // 30 minutes
    });

    const categories = data?.data?.data || [];

    return { isLoading, error, categories, refetch };
}
